module.exports = __webpack_public_path__ + "Roboto-Light.3b813c2ae0d04909a33a.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/roboto/Roboto-Light.woff
// module id = 302
// module chunks = 2